import { defineComponent as _defineComponent } from 'vue'
import { Icon } from '@iconify/vue2'


export default /*#__PURE__*/_defineComponent({
  __name: 'DataPicker',
  props: {
    id: null,
    label: null,
    placeholder: null,
    value: null,
    minDate: null,
    maxDate: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'input', value: string): void
}), expose: any, slots: any, attrs: any }) {





function changeValue(date: Date) {
	emit('input', date.toISOString())
}

return { __sfc: true,emit, changeValue, Icon }
}

})